import React from 'react';
import ReactQuill from 'react-quill';
import DOMPurify from 'dompurify';
import 'react-quill/dist/quill.snow.css';
import { Typography } from '@mui/material';
import ValidationErrorText from '../common/ValidationErrorText';

export default function QuillEditor({ label, value = '', onChange, placeholder, readOnly = false,fieldError }) {
    return (
        <>
            <Typography fontSize="14px" fontWeight="500" mb={1}>
                {label}
            </Typography>
            <ReactQuill
                placeholder={placeholder}
                theme={readOnly ? null : 'snow'}
                readOnly={readOnly}
                value={value}
                onChange={(html) => {
                    const clean = DOMPurify.sanitize(html, {
                        ADD_TAGS: ['u', 'em', 'i'],
                        ADD_ATTR: ['class']
                    });
                    onChange?.(clean);
                }}
                modules={readOnly ? { toolbar: false } : {
                    toolbar: [
                        [{ header: [3, 4, false] }],
                        ['bold', 'italic', 'underline'],
                        [{ list: 'ordered' }, { list: 'bullet' }],
                        ['link', 'clean'],
                    ],
                    clipboard: { matchVisual: false }
                }}
                formats={['header', 'bold', 'italic', 'underline', 'list', 'bullet', 'link']}
            />
            <ValidationErrorText error={fieldError}/>
        </>
    );
}